module.exports = __webpack_public_path__ + "static/media/linkedinIcon.db444cb6.svg";